module.exports = __webpack_public_path__ + "img/image21.963d670d.png";